import type { FC } from 'react'
import { StructuredText } from 'react-datocms'
import styled from 'styled-components'

import type { AcademyHomepageRecord } from '@/graphql/HealthAcademyHomepage'

import { Container } from '@/components/shared/Container'

const StyledHomepageContent = styled.div`
  text-align: center;
  margin-bottom: 90px;
  margin-top: 90px;
  h1 {
    font-family: ${(props) => props.theme.v2.font.nantes};
    margin-bottom: 16px;
  }
  h3 {
    color: ${(props) => props.theme.v2.onSurface.subduedText};
    font-family: ${(props) => props.theme.v2.font.lotaGrotesqueLight};
    margin-bottom: 16px;
  }
  @media screen and (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    margin-bottom: 50px;
    margin-top: 50px;
  }
`

type HomepageContentProps = {
  page: NonNullable<AcademyHomepageRecord>
}

export const HomepageContent: FC<HomepageContentProps> = ({ page }) => {
  return (
    <>
      <Container>
        <StyledHomepageContent>
          <h1>{page.pageTitle}</h1>
          <h3>{page.pageSubtitle}</h3>
          <StructuredText data={page.pageDescription} />
        </StyledHomepageContent>
      </Container>
    </>
  )
}
